import {generateCdnAssetsUrl} from './helpers';

export const getPlayerDefaultAvatarImageUrl = () => generateCdnAssetsUrl(`lineups/player/avatar-default.svg`);
export const getCompetitorDefaultImageUrl = () => generateCdnAssetsUrl(`lineups/team/competitor-logo-default.svg`);
export const getPlayerDefaultJerseyImageUrl = () => generateCdnAssetsUrl(`lineups/team/football-jersey.svg`);
export const getPlayerDefaultJerseyGreyImageUrl = () => generateCdnAssetsUrl(`lineups/team/football-jersey-grey.svg`);
export const getPitchDefaultImageUrl = () => generateCdnAssetsUrl(`lineups/pitch-default.png`);
